import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpUtilsService} from '../_base/crud';
import {ScheduleModel} from '../models/schedule.model';
import {ProjectModel} from '../models/project.model';
import {environment} from '../../../environments/environment';

const API_SCHEDULES_URL = `${environment.pathToAPI}/api/v1/project_schedules`;

@Injectable()
export class ProjectSchedulesService {
    constructor(
        private http: HttpClient,
        private httpUtils: HttpUtilsService) {
    }

    createSchedule(schedule: ScheduleModel): Observable<ProjectModel> {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.post<ProjectModel>(API_SCHEDULES_URL, schedule, {headers: httpHeaders});
    }

    updateSchedule(schedule: ScheduleModel): Observable<ProjectModel> {
        const httpHeader = this.httpUtils.getHTTPHeaders();
        return this.http.put<ProjectModel>(API_SCHEDULES_URL + `/${schedule.id}`, schedule, {headers: httpHeader});
    }

    deleteSchedule(scheduleId: number): Observable<ProjectModel> {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        const url = `${API_SCHEDULES_URL}/${scheduleId}`;
        return this.http.delete<ProjectModel>(url, {headers: httpHeaders});
    }
}
